import React from 'react';
import './MetricsModal.css';

const MetricsModal = ({ selectedMetrics, onMetricsChange, onClose }) => {
    const availableMetrics = [
        { id: 'conversion_rate', label: 'Conversion Rate' },
        { id: 'call_volume', label: 'Call Volume' },
        { id: 'revenue', label: 'Revenue' },
        { id: 'ai_effectiveness', label: 'AI Effectiveness' },
        { id: 'avg_call_duration', label: 'Average Call Duration' },
        { id: 'customer_satisfaction', label: 'Customer Satisfaction' }
    ];

    const handleMetricToggle = (metricId) => {
        if (selectedMetrics.includes(metricId)) {
            onMetricsChange(selectedMetrics.filter(id => id !== metricId));
        } else {
            onMetricsChange([...selectedMetrics, metricId]);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content metrics-modal">
                <div className="modal-header">
                    <h3>Customize Metrics</h3>
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>
                
                <div className="modal-body">
                    <div className="metrics-grid">
                        {availableMetrics.map(metric => (
                            <div 
                                key={metric.id}
                                className={`metric-item ${selectedMetrics.includes(metric.id) ? 'selected' : ''}`}
                                onClick={() => handleMetricToggle(metric.id)}
                            >
                                <div className="metric-checkbox">
                                    {selectedMetrics.includes(metric.id) && '✓'}
                                </div>
                                <span className="metric-label">{metric.label}</span>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="modal-footer">
                    <button className="cancel-btn" onClick={onClose}>Cancel</button>
                    <button className="apply-btn" onClick={onClose}>Apply Changes</button>
                </div>
            </div>
        </div>
    );
};

export default MetricsModal; 